import { render, staticRenderFns } from "./UndoKeyHandler.vue?vue&type=template&id=78705017&"
import script from "./UndoKeyHandler.vue?vue&type=script&lang=ts&"
export * from "./UndoKeyHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports